import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import {SiteModel} from '../../../models/SiteModel';
import {AllSettingsFilterModel} from '../../../models/AllSettingsFilterModel';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {Subscription} from 'rxjs';
import {Offset} from '../../../models/Offset';
import {RegionModel} from '../../../models/RegionModel';
import {ContractTypeModel} from '../../../models/ContractTypeModel';
import {LocalCustomerModel} from '../../../models/LocalCustomerModel';
import {ResourcesUnitModel} from '../../../models/ResourcesUnitModel';
import {ProviderModel} from '../../../models/ProviderModel';
import {DesignServicesModel} from '../../../models/DesignServicesModel';
import {CurrencyModel} from '../../../models/CurrencyModel';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {Router} from '@angular/router';
import {GenericArray} from '../../../models/GenericArray';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import * as toastr from 'toastr';
import {ShareNameDeviceModel} from '../../../models/ShareNameDeviceModel';
import {SharenameDeviceAnagrafService} from '../../general-services/service-sharename-device-anagraf/sharename-device-anagraf.service';

@Component({
  selector: 'app-sharename-device-anagraf',
  templateUrl: './sharename-device-anagraf.component.html',
  styleUrls: ['./sharename-device-anagraf.component.scss']
})
export class SharenameDeviceAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy, OnChanges {

  filter: SiteModel;
  filterAllInSettings: AllSettingsFilterModel;

  displayedColumns: Array<string>;
  dataSource: any;
  isAnagraphSection: boolean;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;
  offset: Offset;
  pageSize: number;
  initAfterOnChange: boolean;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() showActions?: boolean;
  @Input() inAllSettings?: boolean;
  @Input() idSelected?: number;
  @Input() multipleSelection?: boolean;
  @Input() regionForFilterInSettings?: RegionModel;
  @Input() contractTypeForFilterInSettings?: ContractTypeModel;
  @Input() localCustomerForFilterInSettings?: LocalCustomerModel;
  @Input() resourceUnitForFilterInSettings?: ResourcesUnitModel;
  @Input() providerForFilterInSetting?: ProviderModel;
  @Input() designServicesForFilterInSettings?: DesignServicesModel;
  @Input() currencyForFilterInSettings?: CurrencyModel;

  @Input() localCustomerListForFilterInSettings?: Array<LocalCustomerModel>;
  @Input() regionListForFilterInSettings?: Array<RegionModel>;
  @Input() contractTypeListForFilterInSettings?: Array<ContractTypeModel>;

  @Input() shareNameDeviceSelectedList?: Array<ShareNameDeviceModel>;

  @Input() numAnnoMeseFromForFilterInSettings?: number;
  @Input() numAnnoMeseToForFilterInSettings?: number;

  @Output() elementSelected = new EventEmitter();

  constructor(private shareNameAnagrafService: SharenameDeviceAnagrafService,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.isAnagraphSection = ProjectConstants.returnIsAnagraphSection(this.router.url);
    this.showActions = true;
    this.multipleSelection = false;
    this.filter = new ProviderModel();
    this.offset = new Offset();
    this.initAfterOnChange = false;
  }

  ngOnChanges (changes: SimpleChanges) {
    if ('regionForFilterInSettings' in changes
      || 'localCustomerForFilterInSettings' in changes
      || 'resourceUnitForFilterInSettings' in changes
      || 'contractTypeForFilterInSettings' in changes
      || 'designServicesForFilterInSettings' in changes
      || 'currencyForFilterInSettings' in changes
      || 'regionListForFilterInSettings' in changes
      || 'contractTypeListForFilterInSettings' in changes
      || 'localCustomerListForFilterInSettings' in changes) {
      this.initAfterOnChange = true;
      this.getAll(this.offset);
    }
  }

  ngOnInit() {
    if (this.showActions === true) {
      this.displayedColumns = ['shareNameCod', 'shareNameDesc',
        'inArchStructSett', 'actions'];
    } else {
      if (this.multipleSelection) {
        this.displayedColumns = ['isSelected', 'shareNameCod', 'shareNameDesc'];
      } else {
        this.displayedColumns = ['shareNameCod', 'shareNameDesc'];
      }
    }

    this.pageSize = 10;
    this.setOffsetInSession();
    if (!this.initAfterOnChange) {
      this.getAll(this.offset);
    }
  }

  getAll(offset: Offset) {
    this.loaderService.display(true);
    if (this.inAllSettings) {
      this.filterAllInSettings = new AllSettingsFilterModel(this.regionForFilterInSettings,
        this.localCustomerForFilterInSettings,
        this.resourceUnitForFilterInSettings, this.providerForFilterInSetting,
        this.contractTypeForFilterInSettings);

      this.filterAllInSettings.localCustomerList = this.localCustomerListForFilterInSettings;
      this.filterAllInSettings.regionList = this.regionListForFilterInSettings;
      this.filterAllInSettings.contractTypeList = this.contractTypeListForFilterInSettings;

      this.getPageSubscribe = this.shareNameAnagrafService.getPageInAllSettings(offset, this.filterAllInSettings)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.setChecked();
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    } else {
      this.getPageSubscribe = this.shareNameAnagrafService.getPage(offset, this.filter)
        .subscribe(
          (result: any) => {
            this.dataSource = result.content;
            this.listData = new MatTableDataSource(this.dataSource);
            this.paginator.pageIndex = offset.pageIndex;
            this.paginator.showFirstLastButtons = true;
            this.paginator.length = result.totalElements;
            this.loaderService.display(false);
          });
    }
  }

  filterTable() {
    this.getAll(this.offset);
  }

  resetTable() {
    this.filter = new ProviderModel();
    this.getAll(new Offset(10, 0));
  }
  openDialog(id: number) {
    const sharenameData = this.dataSource.find(data => data.id === id) as ShareNameDeviceModel;
    const list: GenericArray[] = [
      { id: 'ShareName Device Cod', value: sharenameData.cod.toString() },
      { id: 'ShareName Device Description', value: sharenameData.description.toString() }
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getAll(this.offset);

  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.shareNameAnagrafService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('Provider with id ' + id + ' was deleted with success', 'Success');
              this.getAll(this.offset);
            } else {
              toastr.info('Provider cannot be deleted', 'Alert');
            }

          }, error => {
            toastr.error('Provider with id ' + id + ' was not deleted', 'Error');
          }
        );
    }
  }

  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.dataSource = dataFiltered.content;
    this.listData = new MatTableDataSource(this.dataSource);
    this.paginator.pageIndex = this.offset.pageIndex;
    this.paginator.length = dataFiltered.totalElements;

  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getAll(this.offset);
    }
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  selectRow(row: any) {
    if (!this.multipleSelection) {
      this.elementSelected.emit({ row });
    }
  }

  selectMultipleRow(row: any) {
    this.elementSelected.emit({ row });
  }

  setOffsetInSession(newOffset?: Offset) {
    if (newOffset) {
      sessionStorage.setItem('sharenameDeviceOffset', JSON.stringify(newOffset));
    } else {
      const sessionOffset = sessionStorage.getItem('sharenameDeviceOffset');
      this.offset = sessionOffset !== 'undefined' && sessionOffset !== null ? JSON.parse(sessionOffset) : new Offset(10, 0);
      this.pageSize = this.offset.pageSize;
    }
  }


  setChecked() {
    if (this.shareNameDeviceSelectedList && this.shareNameDeviceSelectedList.length > 0) {
      for (let _i = 0; _i < this.dataSource.length; _i++) {
        const shareNameDevice: ShareNameDeviceModel = this.dataSource[_i];
        for (let _j = 0; _j < this.shareNameDeviceSelectedList.length; _j++) {
          if (shareNameDevice.id ===  this.shareNameDeviceSelectedList[_j].id) {
            shareNameDevice.checked = true;
          }
        }
      }
    }
  }
}
